import http from "./http";

class PaysService {
    index(){
        return http.get("/api/pays")
    }

}

export default new PaysService()